<template>
  <div style="width: 100% ; float: left">
    <mobile-inquiry-result
      v-if="widget.data.name==='mobileInquiryResult'"
      :widget="widget.data"
    />
  </div>
</template>

<script>
import MobileInquiryResult from '@/views/customComponents/mobileInquiryResult'

export default {
  name: 'CustomComponent',
  components: { MobileInquiryResult },
  props: {
    widget: Object,
  },
}
</script>

<style scoped>

</style>
